const isBlank = (value: unknown): boolean =>
  value == null ||
  value === "" ||
  value === false ||
  value === "Empty Column" ||
  (Array.isArray(value) && value.length === 0);

/**
 * Whether a column shows nothing, so the item view can offer "Add value" in its place. Handles
 * both value shapes the view holds: the backend's flattened shared values and monday's parsed
 * raw values, where a cleared column can still be an object such as `{changed_at}`.
 */
export const isEmptyColumnValue = (value: unknown): boolean => {
  if (isBlank(value)) return true;
  if (typeof value !== "object" || Array.isArray(value)) return false;
  return Object.entries(value as Record<string, unknown>)
    .filter(([key]) => key !== "changed_at")
    .every(([, field]) => isBlank(field));
};
